import React, { useContext } from "react";
import LanguageContext from "../helper/LanguageContext";
import { MailChatRow } from "../pages/Feeds/ChatListParts";
import { formatMailListTime } from "../pages/Feeds/chatListModel";

function isUnreadEmailFlag(value) {
  return value !== true && value !== 1 && value !== "1";
}

/** The row's party: the sender, or the first recipient on Sent. */
function partyOf(item, strings) {
  if (item.direction === "outgoing") {
    const to = Array.isArray(item.toAddresses) ? item.toAddresses : [];
    if (to.length > 0) {
      const first = to[0] || {};
      return {
        name: first.name || first.email || first.address || strings.email_no_recipient || "(no recipient)",
        email: first.email || first.address || "",
      };
    }
  }
  const from = item.fromAddress || {};
  return {
    name: from.name || from.email || from.address || item.senderEmail || strings.email_no_sender || "(unknown sender)",
    email: from.email || from.address || item.senderEmail || "",
  };
}

/**
 * Mail row of the room's All / E-Mail / report lists, in the Messages list's look
 * (ChatListParts MailChatRow): sender, time, the MAIL / report tag and the subject.
 * The room needs no room chip; Mark as task and Delete are the hover quick actions.
 */
export default function EmailFeedRow({
  item,
  selected = false,
  strings = {},
  onOpen,
  onDelete,
  deleting = false,
  onBookmark,
  isBookmarked = false,
}) {
  const { isGerm } = useContext(LanguageContext);
  if (!item) return null;
  const isBriefing = item.systemTag === "daily_briefing";
  const party = partyOf(item, strings);
  const subject = item.subject || strings.email_no_subject || strings.no_subject || "(No subject)";

  const quick = [];
  if (typeof onBookmark === "function" && !isBriefing) {
    quick.push({
      key: "bookmark",
      icon: isBookmarked ? "task_alt" : "add_task",
      active: !!isBookmarked,
      label: isBookmarked
        ? strings.unmark_task || (isGerm ? "Aus Aufgaben entfernen" : "Remove from tasks")
        : strings.mark_as_task || (isGerm ? "Als Aufgabe markieren" : "Mark as task"),
      onSelect: () => onBookmark(item),
    });
  }
  if (typeof onDelete === "function") {
    quick.push({
      key: "delete",
      icon: "delete",
      danger: true,
      disabled: deleting,
      label: strings.delete || (isGerm ? "Löschen" : "Delete"),
      onSelect: () => onDelete(item),
    });
  }

  return (
    <div className="lmp-list lmp-item">
      <MailChatRow
        name={party.name}
        email={party.email}
        subject={subject}
        time={formatMailListTime(item.receivedAt || item.date, {
          yesterday: strings.yesterday || (isGerm ? "Gestern" : "Yesterday"),
          locale: isGerm ? "de-DE" : "en-GB",
        })}
        tag={isBriefing
          ? strings.email_tag_daily_briefing || (isGerm ? "Tagesbericht" : "Daily report")
          : strings.pro_messages_tag_mail || "Mail"}
        unread={isUnreadEmailFlag(item.isRead)}
        open={selected}
        attachment={!!item.hasAttachments}
        attachmentLabel={strings.attachments || (isGerm ? "Anhänge" : "Attachments")}
        quick={quick}
        ariaLabel={party.name || subject}
        onOpen={() => onOpen && onOpen(item)}
      />
    </div>
  );
}
